import {
    CREATE_USER_ADDRESS_REQUEST,
    GET_USER_ADDRESS_REQUEST,
    CHANGE_USER_ADDRESS_REQUEST,
    REMOVE_USER_ADDRESS_REQUEST,
    CREATE_USER_ADDRESS_SUCCESS,
    CHANGE_USER_ADDRESS_SUCCESS,
    REMOVE_USER_ADDRESS_SUCCESS,
    GET_USER_ADDRESS_REQUEST_SUCCESS,
    GET_USER_ADDRESS_REQUEST_FAILURE,
    CHANGE_USER_ADDRESS_FAILURE,
    CREATE_USER_ADDRESS_FAILURE,
    REMOVE_USER_ADDRESS_FAILURE,
} from '../constants/user_address.constants';

const initialState = {
    loading: false,
    addresses: [],
    country: '',
    city: '',
    street: '',
    zip_code: '',
    state: '',
    error: null,
};

export const User_profile_address_table = (state = initialState, action) => {
    switch (action.type) {
    case 'RESET_USER_ADDRESS_DATA':
        return {
            ...state,
            country: '',
            city: '',
            street: '',
            zip_code: '',
            state: '',
        };
    case 'USER_PROFILE_ADDRESS_SET_HANDLER':
        return {
            ...state,
            country: action.country || (action.country === '' && []) || state.country,
            city: action.city || (action.city === '' && []) || state.city,
            street: action.street || (action.street === '' && []) || state.street,
            zip_code: action.zip_code || (action.zip_code === '' && []) || state.zip_code,
            state: action.state || (action.state === '' && []) || state.state,
        };
    case 'SET_USER_ADDRESS_DATA':
        return {
            ...state,
            country: action.payload.country,
            city: action.payload.city,
            street: action.payload.street,
            zip_code: action.payload.zip_code,
            state: action.payload.state,
            _id: action.payload._id,
        };
    case GET_USER_ADDRESS_REQUEST:
    case CREATE_USER_ADDRESS_REQUEST:
    case REMOVE_USER_ADDRESS_REQUEST:
    case CHANGE_USER_ADDRESS_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_USER_ADDRESS_REQUEST_SUCCESS:
    case REMOVE_USER_ADDRESS_SUCCESS:
    case CREATE_USER_ADDRESS_SUCCESS:
    case CHANGE_USER_ADDRESS_SUCCESS:
        return {
            ...state,
            loading: false,
            addresses: action.payload,
            country: '',
            city: '',
            street: '',
            zip_code: '',
            state: '',
        };
    case GET_USER_ADDRESS_REQUEST_FAILURE:
    case REMOVE_USER_ADDRESS_FAILURE:
    case CREATE_USER_ADDRESS_FAILURE:
    case CHANGE_USER_ADDRESS_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/reducers/user_profile_address.reducers.js